<template>
  <div v-loading="loading" class="oa-page expense-form">
    <oa-page-header :title="executive ? '总经理董事长报销' : form.id ? '编辑报销申请' : '发起报销申请'" :description="executive ? '按实际情况填写报销信息' : '按实际支出填写明细，合同与附件分别关联到每笔费用'" back @back="back" />
    <el-alert v-if="error" :title="error" type="error" show-icon :closable="false" />
    <el-alert v-if="!loading && !config.enabled" title="报销制度尚未启用，当前可保存草稿" type="warning" show-icon :closable="false" />
    <div v-if="!accessDenied" class="expense-layout">
      <el-form ref="form" :model="form" label-position="top" class="form-body" :disabled="saving" @submit.native.prevent>
        <section class="block">
          <div class="section-heading"><h3><span>1</span>申请信息</h3></div>
          <el-form-item label="提交人"><span>{{ currentUserName || form.submitterName }}</span></el-form-item>
          <el-row :gutter="20">
            <el-col :xs="24" :md="8"><el-form-item label="报销人" required><el-select v-model="form.beneficiaryId" @change="changeBeneficiary" filterable><el-option v-for="u in users" :key="u.id" :label="u.name" :value="u.id" /></el-select></el-form-item></el-col>
            <el-col :xs="24" :md="8"><el-form-item label="所在部门" required><el-select v-model="form.deptId" filterable @change="changeDepartment"><el-option v-for="d in departments" :key="d.id" :label="d.name" :value="d.id" /></el-select></el-form-item></el-col>
          </el-row>
          <el-form-item v-if="executive" label="报销类型"><el-select v-model="reimbursementTypes" multiple clearable placeholder="可不选"><el-option v-for="x in ['出差费用','招待费','其他费用']" :key="x" :label="x" :value="x" /></el-select></el-form-item>
          <el-form-item v-if="executive" label="报销金额（元）" required><el-input v-model="executiveAmount" :disabled="items.length > 0" inputmode="decimal" maxlength="12" placeholder="无明细时手动填写报销金额" /><p class="muted">{{ items.length ? '按费用明细自动合计' : '无费用明细时，提交前须填写报销金额' }}</p></el-form-item>
          <el-row :gutter="24">
            <el-col v-if="!executive" :xs="24" :md="14"><el-form-item label="支付公司" required><el-select v-model="form.payerCompanyId" filterable placeholder="选择支付公司"><el-option v-for="c in companies" :key="c.id" :label="c.companyName" :value="c.id" /></el-select></el-form-item></el-col>
            <el-col v-if="!executive" :xs="24" :md="10"><el-form-item label="预算类型" required><el-radio-group v-model="form.budgetType"><el-radio label="IN">预算内</el-radio><el-radio label="OUT">预算外</el-radio></el-radio-group></el-form-item></el-col>
            <el-col v-if="!executive && form.budgetType === 'OUT'" :span="24"><el-form-item label="预算外原因" required><el-input v-model="form.budgetReason" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="说明预算外支出的原因" /></el-form-item></el-col>
            <el-col v-if="!executive" :span="24"><el-form-item><el-checkbox :value="form.procurementType === 'PROJECT'" @change="v => form.procurementType = v ? 'PROJECT' : 'NONE'">含项目采购</el-checkbox><el-checkbox :value="form.procurementType === 'NON_PROJECT'" @change="v => form.procurementType = v ? 'NON_PROJECT' : 'NONE'">含非项目采购</el-checkbox></el-form-item></el-col>
            <el-col :span="24"><el-form-item label="报销事由" :required="!executive"><el-input v-model="form.reason" type="textarea" :rows="3" maxlength="1000" placeholder="本次报销用于什么业务" /></el-form-item></el-col>
          </el-row>
        </section>
        <section class="block">
          <div class="section-heading"><h3><span>2</span>费用明细</h3><span class="muted">{{ items.length }} 笔</span></div>
          <article v-for="(item, i) in items" :key="item.localKey" class="expense-item">
            <div class="item-heading"><el-button type="text" class="item-toggle" :icon="item.collapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'" @click="$set(item, 'collapsed', !item.collapsed)">明细 {{ i + 1 }}{{ executive ? '' : ' · ' }}{{ executive ? '' : isEntertainment(item.category) ? '招待费' : item.category }} <span v-if="item.collapsed"> · ¥ {{ money(item.amount) }}</span></el-button><el-button type="text" icon="el-icon-delete" class="danger" @click="removeItem(i)">删除</el-button></div>
            <div v-show="!item.collapsed" class="item-body">
              <el-row :gutter="20">
                <el-col v-if="!executive" :xs="24" :md="12"><el-form-item label="费用类别" required><el-select v-model="item.category" filterable placeholder="输入名称筛选费用类型" @change="changeCategory(item)"><el-option v-for="x in categories" :key="x" :label="x" :value="x" /></el-select></el-form-item></el-col>
                <el-col v-if="executive" :span="24"><el-form-item label="明细"><el-input v-model="item.description" maxlength="500" placeholder="请输入" /></el-form-item></el-col>
                <el-col :xs="24" :md="executive ? 24 : 12"><el-form-item label="金额（元）" :required="!executive"><el-input v-model="item.amount" inputmode="decimal" placeholder="0.00" maxlength="12" /></el-form-item></el-col>
                <el-col v-if="!executive" :span="24"><el-form-item label="关联合同" required><el-select :value="item.noContract ? 'NONE' : item.contractId" filterable remote clearable :remote-method="q => searchContracts(item, q)" :loading="item.contractLoading" @focus="searchContracts(item, '')" @change="value => changeContract(item, value)" placeholder="搜索合同编号、合同名称或客户名称"><el-option label="无" value="NONE" /><el-option v-for="c in item.contractOptions" :key="c.id" :label="c.name" :value="c.id" /></el-select></el-form-item></el-col>
                <el-col v-if="!executive && item.noContract" :span="24"><el-form-item label="无合同说明" required><el-input v-model="item.noContractReason" placeholder="请说明本笔费用无关联合同的原因" maxlength="500" show-word-limit /></el-form-item></el-col>
                <template v-if="!executive && isEntertainment(item.category)">
                  <el-col :xs="24" :md="12"><el-form-item label="关联客户" required><el-autocomplete :value="item.customerName" clearable :maxlength="255" :highlight-first-item="false" :fetch-suggestions="(query, done) => searchCustomers(item, query, done)" @input="value => inputCustomer(item, value)" @select="customer => changeCustomer(item, customer)" placeholder="输入客户名称或选择已有客户" /></el-form-item></el-col>
                  <el-col :xs="24" :md="12"><el-form-item label="联系人（可选）"><el-select v-model="item.contactId" filterable remote clearable :disabled="!item.customerId" :remote-method="q => searchContacts(item, q)" :loading="item.contactLoading" @focus="searchContacts(item, '')" :placeholder="item.customerId ? '选择该客户的联系人' : '手填客户无需关联联系人'"><el-option v-for="c in item.contactOptions" :key="c.id" :label="c.name" :value="c.id" /></el-select></el-form-item></el-col>
                </template>
                <el-col v-if="!executive" :span="24"><el-form-item :label="executive ? '明细' : '费用说明'" :required="!executive"><el-input v-model="item.description" maxlength="500" placeholder="填写费用内容" /></el-form-item></el-col>

                <el-col v-if="!executive" :span="24"><el-form-item label="明细附件（可选）"><file-upload upload-path="/crmExpenseClaim/upload" v-model="item.attachments" :limit="12" :multiple="true" /></el-form-item></el-col>
              </el-row>
            </div>
          </article>
          <el-button class="add-item" plain icon="el-icon-plus" @click="addItem">添加费用</el-button>
        </section>
        <section v-if="executive" class="block">
          <el-form-item label="发票"><file-upload upload-path="/crmExpenseClaim/upload" v-model="invoiceAttachments" :limit="12" :multiple="true" /></el-form-item>
          <el-form-item label="附件"><file-upload upload-path="/crmExpenseClaim/upload" v-model="claimAttachments" :limit="12" :multiple="true" /></el-form-item>
          <el-form-item label="图片"><file-upload upload-path="/crmExpenseClaim/upload" v-model="imageAttachments" :limit="9" :multiple="true" accept="image/*" /></el-form-item>
        </section>
        <section v-if="!executive && claimAttachments.length" class="block"><h3>历史整单附件</h3><file-upload :value="claimAttachments" :read-only="true" /></section>
      </el-form>
      <aside class="summary-panel">
        <h3>报销合计</h3><div class="summary-total">{{ summary.total === '待填写' ? '' : '¥ ' }}{{ summary.total }}</div><p class="muted">共 {{ items.length }} 笔费用</p>
        <dl v-if="!executive"><dt>支付公司</dt><dd>{{ payerCompany.companyName || '待选择' }}</dd><dt>预算类型</dt><dd>{{ form.budgetType === 'OUT' ? '预算外' : '预算内' }}</dd></dl>
        <dl><dt>报销人</dt><dd>{{ beneficiaryName }}</dd><dt>报销部门</dt><dd>{{ form.deptName || department.deptName || '—' }}</dd><dt>报销日期</dt><dd>提交时自动生成</dd></dl>
        <p class="muted"><i class="el-icon-paperclip" /> {{ attachmentCount }} 份附件</p>
        <p v-if="['PROJECT','NON_PROJECT'].includes(form.procurementType)" class="muted">{{ form.procurementType === 'PROJECT' ? '含项目采购' : '含非项目采购' }}</p>
        <oa-route-preview :steps="routePreview.steps" :cc-names="routePreview.ccNames" :cc-label="routePreview.ccTiming" :initiator="routePreview.submitterName" :loading="routePreviewLoading" :error="routePreviewError" @refresh="refreshRoutePreview" />
        <el-button type="primary" :disabled="loading || !config.enabled || saving" @click="save(true)" :loading="saving">提交审批</el-button><el-button :loading="saving" :disabled="loading || saving" @click="save(false)">保存草稿</el-button>
      </aside>
    </div>
  </div>
</template>
<script>
import OaRoutePreview from '@/views/oa/components/OaRoutePreview'
import FileUpload from '@/views/crm/components/fileUpload'
import OaPageHeader from '@/views/oa/components/OaPageHeader'
import { safeReturn } from '@/utils/oa'
import {
  expenseOptions,
  expenseDetail,
  expenseTargets,
  expenseContacts,
  expenseProducts,
  expenseBeneficiary,
  saveExpense,
  submitExpense,
  previewExpenseApproval,
} from '@/api/crm/expense'
import {

  money,
  totals,
  claimTotals,
  files,
  newItem,
  toCents,
  validateClaim,
  paymentCompanies,
  contractNumber,
  claimFiles,
  claimInput,
  itemInput,
} from '@/utils/expense'
export default {
  name: 'ExpenseClaimForm',
  components: { OaRoutePreview, FileUpload, OaPageHeader },
  data() {
    return {

      routePreview:{},routePreviewLoading:false,routePreviewError:'',routePreviewTimer:null,routePreviewSeq:0,
      baseline: '',
      leaving: false,
      loading: true,
      saving: false,
      personVisible: false,
      error: '',
      permissions: {},
      accessDenied: false,
      config: {},
      companies: [],
      users: [],
      department: {},
      departments: [],
      categories: [],
      items: [],
      currentUserName: '',
      reimbursementTypes: [],
      invoiceAttachments: [],
      imageAttachments: [],
      claimAttachments: [],
      form: {
        claimType: 'NORMAL',
        budgetType: 'IN',
        procurementType: 'NONE',
        reason: '',
        totalAmount: '',
        payerCompanyId: null,
        beneficiaryId: null,
      },
    }
  },
  computed: {
    routePreviewKey(){return JSON.stringify([this.loading,this.form.id,this.form.claimType,this.form.beneficiaryId,this.form.deptId,this.form.budgetType,this.form.procurementType,this.form.totalAmount,this.items.map(x=>x.amount)])},
    executive() { return this.form.claimType === 'EXECUTIVE' },
    executiveAmount: { get() { return this.items.length ? this.summary.total : this.form.totalAmount }, set(value) { if (!this.items.length) this.$set(this.form, 'totalAmount', value) } },
    summary() {
      try {
        return claimTotals(this.form, this.items)
      } catch (e) {
        return { total: '金额待完善' }
      }
    },
    payerCompany() { return this.companies.find(c => c.id === this.form.payerCompanyId) || {} },
    beneficiaryName() { return (this.users.find(u => u.id === this.form.beneficiaryId) || {}).name || this.form.beneficiaryName || '—' },
    attachmentCount() { return this.claimAttachments.length + this.invoiceAttachments.length + this.imageAttachments.length + this.items.reduce((n, x) => n + (x.attachments || []).length, 0) },
  },
  watch:{routePreviewKey:{immediate:true,handler(){this.queueRoutePreview()}}},
  beforeDestroy(){clearTimeout(this.routePreviewTimer);this.routePreviewSeq++},
  async created() {
    try {
      this.form.claimType = this.$route.query.claimType === 'EXECUTIVE' ? 'EXECUTIVE' : 'NORMAL'
      const r = await expenseOptions()
      Object.assign(this, {
        permissions: r.data.permissions || {},
        config: r.data.config || {},
        companies: paymentCompanies(r.data.companies),
        users: r.data.users || [],
        department: r.data.department || {},
        departments: r.data.departments || [],
        categories: r.data.categories || [],
      })
      if (this.executive && !this.permissions.executiveApply) { this.accessDenied = true; throw new Error('没有总经理董事长报销提交权限') }
      this.currentUserName = r.data.userName || (this.users.find(x => x.id === r.data.userId) || {}).name || '当前账号'
      this.form.beneficiaryId = r.data.userId
      this.$set(this.form, 'deptId', this.department.deptId)
      this.$set(this.form, 'deptName', this.department.deptName)
      if (this.companies.length === 1) {
        this.form.payerCompanyId = this.companies[0].id
      }
      if (this.$route.query.id) {
        const d = await expenseDetail(this.$route.query.id)
        if (d.data.claim.claimType === 'EXECUTIVE' && !this.permissions.executiveApply) { this.accessDenied = true; throw new Error('没有总经理董事长报销提交权限') }
        if (!d.data.canEdit) throw new Error('当前单据不能修改')
        this.form = { ...d.data.claim, totalAmount: d.data.claim.originalAmountProvided === false ? '' : d.data.claim.totalAmount }
        this.reimbursementTypes = JSON.parse(this.form.reimbursementTypes || '[]')
        this.invoiceAttachments = files(this.form.invoiceFileObjs)
        this.imageAttachments = files(this.form.imageFileObjs)
        this.claimAttachments = claimFiles(d.data.claim, d.data.items)
        this.items = d.data.items.map((x, i) => ({
          ...x,
          category: x.category === '业务招待' ? '招待费' : x.category,
          attachments: files(x.fileObjs),
          contractName: x.contractName || '',
          contractOptions: x.contractId ? [{ id: x.contractId, name: x.contractName || '' }] : [],
          localKey: i + '-' + Date.now(),
          productOptions: x.productId
            ? [
                {
                  id: x.productId,
                  name: [x.productCode, x.productName, x.productVersion].join(
                    ' / ',
                  ),
                },
              ]
            : [],
          customerOptions: x.customerId ? [{ id: x.customerId, name: x.customerName }] : [],
          contactOptions: x.contactId ? [{ id: x.contactId, name: x.contactName }] : [],
          searching: false,
        }))
      } else if (!this.executive) this.addItem()
    } catch (e) {
      this.error = e.message || '报销表单加载失败'
    } finally {
      this.loading = false
      this.baseline = this.fingerprint()
    }
  },
  beforeRouteLeave(to, from, next) { if (this.leaving || !this.baseline || this.fingerprint() === this.baseline) return next(); this.$confirm('修改尚未保存，离开后将丢失本次修改。','离开申请',{confirmButtonText:'离开',cancelButtonText:'继续填写',type:'warning'}).then(() => next()).catch(() => next(false)) },
  methods: {
    queueRoutePreview(){clearTimeout(this.routePreviewTimer);this.routePreviewSeq++;if(this.loading || this.accessDenied)return;this.routePreviewLoading=true;this.routePreviewTimer=setTimeout(()=>this.refreshRoutePreview(),350)},
    async refreshRoutePreview(){if(this.loading || this.accessDenied)return;const seq=++this.routePreviewSeq;this.routePreviewLoading=true;this.routePreviewError='';try{const d=(await previewExpenseApproval({claim:{id:this.form.id,claimType:this.form.claimType,beneficiaryId:this.form.beneficiaryId,deptId:this.form.deptId,budgetType:this.form.budgetType,procurementType:this.form.procurementType,totalAmount:this.form.totalAmount||'0'},items:this.items.map(x=>({amount:x.amount||'0'}))})).data;if(seq===this.routePreviewSeq){this.routePreview=d;this.routePreviewError=(d.blockers||[]).join('；')}}catch(e){if(seq===this.routePreviewSeq){this.routePreview={};this.routePreviewError=e.message||'流程预览读取失败，请刷新'}}finally{if(seq===this.routePreviewSeq)this.routePreviewLoading=false}},
    fingerprint() { this.syncExecutiveFields(); return JSON.stringify({claim:claimInput(this.form,this.claimAttachments),items:this.items.map(itemInput)}) },
    syncExecutiveFields() {
      if (!this.executive) return
      this.$set(this.form, 'reimbursementTypes', JSON.stringify(this.reimbursementTypes))
      this.$set(this.form, 'invoiceFileObjs', JSON.stringify(this.invoiceAttachments))
      this.$set(this.form, 'imageFileObjs', JSON.stringify(this.imageAttachments))
    },
    changeDepartment(id) { this.$set(this.form, 'deptName', (this.departments.find(d => d.id === id) || {}).name || '') },
    changeContract(item, value) { this.$set(item, 'noContract', value === 'NONE'); this.$set(item, 'noContractReason', ''); this.$set(item, 'contractId', value === 'NONE' ? null : value || null); this.$set(item, 'contractName', (item.contractOptions.find(c => c.id === item.contractId) || {}).name || '') },
    async searchContracts(item, keyword) {
      const seq = item.contractRequest = (item.contractRequest || 0) + 1
      this.$set(item, 'contractLoading', true)
      try {
        const r = await expenseTargets({ type: 'contract', keyword, beneficiaryId: this.form.beneficiaryId, claimId: this.form.id })
        if (seq !== item.contractRequest) return
        const rows = r.data || []
        if (item.contractId && !rows.some(x => x.id === item.contractId)) rows.unshift({ id: item.contractId, name: item.contractName })
        this.$set(item, 'contractOptions', rows)
      } catch (e) { this.$message.error(e.message || '合同查询失败') }
      finally { if (seq === item.contractRequest) this.$set(item, 'contractLoading', false) }
    },
    async changeBeneficiary(id) {
      const seq = this.beneficiaryRequest = (this.beneficiaryRequest || 0) + 1
      try {
        const r = await expenseBeneficiary(id)
        if (seq !== this.beneficiaryRequest) return
        this.$set(this.form, 'deptId', r.data.deptId)
        this.$set(this.form, 'deptName', r.data.deptName)
        this.items.forEach((x) => {
          this.changeCategory(x, true)
          Object.assign(x, { contractId: null, contractName: '', noContract: false, noContractReason: '', contractOptions: [] }); x.contractRequest = (x.contractRequest || 0) + 1
        })
      } catch (e) {
        this.error = e.message
      }
    },
    async searchProducts(item, keyword) {
      try {
        const r = await expenseProducts({ keyword })
        this.$set(item, 'productOptions', r.data || [])
      } catch (e) {
        this.$message.error(e.message || '商品查询失败')
      }
    },
    money,
    isEntertainment(category) { return ['招待费', '业务招待'].includes(category) },
    addItem() {
      if (this.items.length >= 100)
        return this.$message.warning('最多100条费用')
      this.items.push({
        ...newItem(),
        localKey: Date.now() + '-' + Math.random(),
        searching: false,
      })
    },
    validate(submitting) {
      this.syncExecutiveFields()
      validateClaim(this.form, this.items, submitting)
    },
    customerLabel(item) { return (item.customerOptions.find(c => c.id === item.customerId) || {}).name || item.customerName },
    async removeItem(i) {
      try { await this.$confirm('删除这笔费用？', '删除费用', { type: 'warning' }); this.items.splice(i, 1); if (this.executive && !this.items.length) this.$set(this.form, 'totalAmount', '') } catch (_) {}
    },
    changeCategory(item, force) {
      if (!this.isEntertainment(item.category) || force) {
        Object.assign(item, { customerId: null, customerName: '', contactId: null, contactName: '', customerOptions: [], contactOptions: [] })
        item.customerRequest = (item.customerRequest || 0) + 1
        item.contactRequest = (item.contactRequest || 0) + 1
      }
    },
    inputCustomer(item, value) {
      this.$set(item, 'customerId', null)
      this.$set(item, 'customerName', value || '')
      item.customerRequest = (item.customerRequest || 0) + 1
      this.$set(item, 'customerOptions', [])
      this.$set(item, 'contactId', null); this.$set(item, 'contactName', '')
      this.$set(item, 'contactOptions', [])
      item.contactRequest = (item.contactRequest || 0) + 1
    },
    changeCustomer(item, customer) {
      this.inputCustomer(item, customer.name)
      this.$set(item, 'customerId', customer.id)
      this.$set(item, 'customerOptions', [customer])
      this.searchContacts(item, '')
    },
    async searchCustomers(item, keyword, done) {
      const seq = item.customerRequest = (item.customerRequest || 0) + 1
      this.$set(item, 'customerLoading', true)
      try {
        const r = await expenseTargets({ type: 'customer', keyword, beneficiaryId: this.form.beneficiaryId, claimId: this.form.id })
        if (seq === item.customerRequest) {
          const rows = (r.data || []).map(customer => ({ ...customer, value: customer.name }))
          this.$set(item, 'customerOptions', rows)
          done(rows)
        }
      } catch (e) {
        if (seq === item.customerRequest) {
          this.$set(item, 'customerOptions', [])
          done([])
          this.$message.error(e.message || '客户查询失败')
        }
      }
      finally { if (seq === item.customerRequest) this.$set(item, 'customerLoading', false) }
    },
    async searchContacts(item, keyword) {
      if (!item.customerId) return
      const seq = item.contactRequest = (item.contactRequest || 0) + 1
      this.$set(item, 'contactLoading', true)
      try {
        const r = await expenseContacts({ customerId: item.customerId, keyword, beneficiaryId: this.form.beneficiaryId, claimId: this.form.id })
        if (seq === item.contactRequest) this.$set(item, 'contactOptions', r.data || [])
      } catch (e) { this.$message.error(e.message || '联系人查询失败') }
      finally { if (seq === item.contactRequest) this.$set(item, 'contactLoading', false) }
    },
    async save(submitting) {
      if (this.accessDenied) return
      if (this.saving) return
      try {
        this.validate(submitting)
        this.saving = true
        this.error = ''
        if (submitting) {
          const preview = (await previewExpenseApproval({ claim: this.form, items: this.items.map(x => ({ ...x, amount: x.amount || '0' })) })).data
          this.routePreview=preview
          if (!preview.canSubmit) throw Error(preview.blockers.join('；'))
        }
        const body = { claim: claimInput(this.form, this.claimAttachments), items: this.items.map(itemInput) }
        const r = await saveExpense(body)
        const d = await expenseDetail(r.data)
        this.form = d.data.claim
        if (submitting)
          await submitExpense({
            id: this.form.id,
            revision: this.form.revision,
          })
        this.$message.success(submitting ? '已提交审批' : '草稿已保存')
        this.leaving = true
        this.$router.replace({path:'/finance/expense/detail/' + this.form.id,query:{returnTo:safeReturn(this.$route,'/oa/expense-claims')}})
      } catch (e) {
        this.error = e.message || '保存失败'
        this.items.forEach(x => this.$set(x, 'collapsed', false))
        this.$message.error(this.error)
      } finally {
        this.saving = false
      }
    },
    back() {
      this.$router.push(safeReturn(this.$route,'/oa/expense-claims'))
    },
  },
}
</script>
<style scoped>
.applicant-facts { display:grid; grid-template-columns:1fr 1fr; gap:16px; background:#f7f9fc; padding:14px 18px; border-radius:6px; margin-bottom:22px; }
.applicant-facts span { display:block; color:#718095; font-size:13px; margin-bottom:7px; }
.applicant-facts strong { font-weight:500; line-height:1.6; overflow-wrap:anywhere; }
.expense-form { max-width: 1520px; margin: auto; padding: 24px 28px 40px; color: #263b53; }
.heading { display:flex; justify-content:space-between; align-items:center; gap:20px; margin-bottom:18px; }
.heading h2 { display:inline-block; margin:0 0 0 16px; color:#172b4d; font-size:25px; }
.muted { color:#7b8799; font-size:13px; line-height:1.7; }
.expense-layout { display:grid; grid-template-columns:minmax(0, 1fr) 290px; gap:24px; align-items:start; margin-top:18px; }
.block { background:white; border:1px solid #e5eaf1; border-radius:6px; padding:22px 24px 2px; margin-bottom:20px; }
.block.compact { padding:20px 24px; }
.block.compact .el-form-item { margin-top:18px; }
h3 { margin:0; font-size:18px; color:#172b4d; }
h3 span { display:inline-block; padding-right:15px; color:#397eff; }
.section-heading, .item-heading { display:flex; align-items:center; justify-content:space-between; gap:12px; }
.section-heading { margin-bottom:22px; min-height:26px; }
.expense-item { border:1px solid #e5eaf1; border-radius:5px; margin-bottom:18px; overflow:hidden; }
.item-heading { background:#f5f8fc; padding:0 18px; min-height:46px; }
.item-toggle { color:#263b53; font-weight:600; text-align:left; white-space:normal; }
.item-body { padding:20px 18px 0; }
.danger { color:#b96565; }
.add-item { width:100%; border-style:dashed; margin-bottom:22px; }
.summary-panel { background:#fff; border:1px solid #e5eaf1; border-radius:6px; padding:24px 20px; position:sticky; top:100px; }
.summary-total { font-size:30px; color:#397eff; font-weight:600; margin-top:22px; overflow-wrap:anywhere; }
.summary-panel dl { border-top:1px solid #e5eaf1; padding-top:18px; margin:22px 0; }
dt { color:#687b94; font-size:13px; margin-bottom:8px; }
dd { margin:0 0 18px; font-size:14px; line-height:1.6; overflow-wrap:anywhere; }
.summary-panel .el-button { display:block; width:100%; margin:12px 0 0; }
.form-body >>> .el-select, .form-body >>> .el-date-editor, .form-body >>> .el-autocomplete { width:100%; }
.form-body >>> .el-form-item__label { padding-bottom:7px; line-height:22px; color:#374a63; font-weight:500; }
.form-body >>> .el-form-item { margin-bottom:20px; }
.form-body >>> .el-radio { margin-right:20px; }
@media(max-width:1100px) { .expense-layout { grid-template-columns:minmax(0,1fr) 245px; gap:16px; } .block { padding-left:18px; padding-right:18px; } }
@media(max-width:850px) { .expense-layout { grid-template-columns:1fr; } .summary-panel { position:static; } .heading { flex-wrap:wrap; } .expense-form { padding:18px 12px; } }
</style>

<style lang="scss">@import '../../oa/oa.scss';</style>
<style scoped>
.expense-form.oa-page{max-width:none;margin:0}.expense-form .expense-layout{grid-template-columns:minmax(0,1fr) 278px;gap:24px}.expense-form .block{border-color:#e6ebf2;border-radius:8px;padding:24px;margin-bottom:20px}.expense-form .summary-panel{border-color:#e6ebf2;border-radius:8px;top:110px;padding:24px}.expense-form .summary-panel h3{font-size:13px;font-weight:400;color:#8a96a8}.expense-form .summary-total{font-size:30px;font-weight:600;letter-spacing:0;color:#4480f3;font-variant-numeric:tabular-nums}.expense-form .section-heading h3{font-size:16px;color:#354258}.expense-form .section-heading h3>span{background:#f0f4fc;color:#7b91b1;font-size:12px}.expense-form .expense-item{border-color:#e9edf4;border-radius:6px;background:#fff}.expense-form .item-heading{background:#fafbfd}.expense-form::v-deep .el-form-item__label{color:#67758a;font-weight:500;line-height:1.6;padding-bottom:8px}.expense-form::v-deep .el-form-item{margin-bottom:24px}
@media(max-width:1180px){.expense-form .expense-layout{grid-template-columns:minmax(0,1fr) 240px;gap:18px}}
@media(max-width:850px){.expense-form .expense-layout{display:block}.expense-form .summary-panel{position:static}.expense-form .block{padding:18px}}
</style>
